  <template>
<tr :class="(member.bookNum !== '') ? 'active' : ''">
  <td>{{index + 1}}</td>
  <td>{{ member.bookNum }}</td>
  <td>{{ formatDate(member.registeredDate) }}</td>
  <td>
    <ul>
      <li v-for="(classification, i) in member.classifications" v-bind:key="i">{{classification}}</li>
    </ul>
  </td>
  <td>{{ formatDate(getLastBooking()) }}</td>
  <td>{{member.refusals.length}}</td>
  <td>{{member.absences.length}}</td>
</tr>
</template>

<script>
export default {
  name: "table-row",
  props: {
    member: null,
    index: 0
  },
  methods: {
    getLastBooking() {
      if (this.member.bookings.length == 0) {
        return "";
      }
      return this.member.bookings.reduce(
        (max, p) => (p.date > max ? p.date : max),
        this.member.bookings[0].date
      );
    },
    formatDate(date) {
      if (date === "") {
        return "";
      }
      var d = new Date(date);
      return d.toLocaleDateString("en-US", {
        month: "numeric",
        day: "numeric",
        year: "2-digit",
        hour: "numeric",
        minute: "numeric"
      });
    }
  }
};
</script>

<style scoped>
ul {
  padding: 0px;
}
li {
  list-style: none;
}
tr:nth-child(even) {
  background-color: #f2f2f2;
}
tr.active {
  background-color: #75ca2a;
  font-weight: bold;
}
</style>





// WEBPACK FOOTER //
// src/components/member_queue_row.vue